import RecommendCarianModalforOta from './RecommendCarianModalforOta';

export default RecommendCarianModalforOta;
